import { $vfm } from 'vue-final-modal';
import { IgcModal } from '@/components';
import { IgcModalProps } from './IgcModalService.model';

export const DEFAULT_MODAL_NAME = 'defaultModal';

const defaultModalParams = {
  name: 'IgcModal',
  height: 'auto',
  adaptive: true,
  maxWidth: 345,
  styles: 'overflow: visible; border-radius: 10px;',
};

export class IgcModalService {
  async show(props: IgcModalProps, modalParams: any = {}, hooks: any = null) {
    // eslint-disable-next-line no-unsafe-optional-chaining
    const mergedStyles = defaultModalParams.styles + modalParams?.styles;

    let modalResolve;
    let modalReject;

    const modalPromise = new Promise((resolve, reject) => {
      modalResolve = resolve;
      modalReject = reject;
    });

    const mergedParams = {
      ...defaultModalParams,
      ...modalParams,
      styles: mergedStyles,
    };

    $vfm.show({
      component: IgcModal,
      bind: {
        ...mergedParams,
        ...hooks,
        ...props,
        resolve: modalResolve,
        reject: modalReject,
      },
    });

    return modalPromise;
  }

  hide() {
    $vfm.hideAll();
  }

  toggle() {
    // Toggle works, but is potentially buggy for more than 1 modal present on page. If you need to use it - better
    // provide modal name or locate it somehow.
    // For this reason toggle is not exposed by default in helpers.ts
    ($vfm.modals[0] as any)?.toggle();
  }
}
